import { AnimatePresence } from 'framer-motion';
import { PRESETS } from './MembraneField';
import FieldEditor from './FieldEditor';
import Arrow from './Arrow';
import { useField } from '../lib/field';

// Step through the backdrop's presets, or open the edit panel. Used in the
// hero's foot and on the playground page; both drive the one field.
export const FieldPresets = () => {
  const { preset, edited, editing, step, setEditing } = useField();
  return (
    <div className="hero-presets" role="group" aria-label="Field preset">
      <span className="hero-credit-label">
        {edited ? 'Edited' : `Preset ${String(preset + 1).padStart(2, '0')}/${String(PRESETS.length).padStart(2, '0')}`}
      </span>
      <div className="hero-presets-row">
        <button type="button" className="hero-presets-step" onClick={() => step(-1)} aria-label="Previous preset">
          <Arrow dir="left" size={12} />
        </button>
        <button type="button" className="hero-presets-name" onClick={() => step(1)} aria-live="polite">
          {edited ? 'Custom' : PRESETS[preset].label}
        </button>
        <button type="button" className="hero-presets-step" onClick={() => step(1)} aria-label="Next preset">
          <Arrow size={12} />
        </button>
        <button
          type="button"
          className={`hero-presets-edit ${editing ? 'is-on' : ''}`}
          onClick={() => setEditing((open) => !open)}
          aria-expanded={editing}
        >
          Edit
        </button>
      </div>
    </div>
  );
};

// The edit panel, placed by whatever holds it (App.css .field-editor).
export const FieldPanel = () => {
  const { look, editing, edit, reset, setEditing } = useField();
  return (
    <AnimatePresence>
      {editing && <FieldEditor look={look} onChange={edit} onReset={reset} onClose={() => setEditing(false)} />}
    </AnimatePresence>
  );
};
